import { useEffect } from 'react'
import { classes, keyframes, style, stylesheet } from 'typestyle'

import { get } from '../../../__aeki__/share/find'
import { useLocation, useNavigate } from 'react-router-dom'
import useFetch, { parseSearch } from '../../../__aeki__/hooks/use-fetch'

import { Box } from '../../../__aeki__/components/box/box.component'
import { Button } from '../../../__aeki__/components/button'
import { Line } from '../../../__aeki__/components/line'
import { Heading } from '../../../__aeki__/components/text/heading.component'
import { Text } from '../../../__aeki__/components/text/text.component'
import { A } from '../../../__aeki__/components/a'

import { mb4 } from '../../../__aeki__/styles/styleset/margin/mb4'
import { mb8 } from '../../../__aeki__/styles/styleset/margin/mb8'
import { mr4 } from '../../../__aeki__/styles/styleset/margin/mr4'
import { mt8 } from '../../../__aeki__/styles/styleset/margin/mt8'
import { p4 } from '../../../__aeki__/styles/styleset/padding/p4'
import { pl8i } from '../../../__aeki__/styles/styleset/padding/pl8i'
import { pr8i } from '../../../__aeki__/styles/styleset/padding/pr8i'
import { mb32 } from '../../../__aeki__/styles/styleset/margin/mb32'
import { hidemdi } from '../../../__aeki__/styles/styleset/hide/hidemdi'
import { pr8 } from '../../../__aeki__/styles/styleset/padding/pr8'
import { f16i } from '../../../__aeki__/styles/styleset/font-size/f16i'
import { f14mdi } from '../../../__aeki__/styles/styleset/font-size/f14mdi'
import { f18i } from '../../../__aeki__/styles/styleset/font-size/f18i'
import { Marker } from '../../childcares/components/marker'
import { CenterMarker } from '../../../__aeki__/components/google-map/google-center-marker'
import GoogleMap from '../../../__aeki__/components/google-map'
import { GoogleLoader } from '../../../__aeki__/components/google-map/google-loader'
import { Modal } from '../../../__aeki__/components/modal'
import useObject from '../../../__aeki__/hooks/use-object'
import { structureObj, flat } from '../../../__aeki__/share/obj-equal'
import childcare from '../../childcare'
import useValue from '../../../__aeki__/hooks/use-value'
import useCounter from '../../../__aeki__/hooks/use-counter'
import { HEADER_HEIGHT } from '../../../__aeki__/components/app-layout/app-layout.constants'
import { paddingVerticalInner } from '../../../__aeki__/styles/default/padding'
import { pb40 } from '../../../__aeki__/styles/styleset/padding/pb40'
import { pt40 } from '../../../__aeki__/styles/styleset/padding/pt40'
import { MAX_WIDTH } from '../layout'
import { pb12 } from '../../../__aeki__/styles/styleset/padding/pb12'
import { mb16 } from '../../../__aeki__/styles/styleset/margin/mb16'
import { f14i } from '../../../__aeki__/styles/styleset/font-size/f14i'
import { f17i } from '../../../__aeki__/styles/styleset/font-size/f17i'
import { pl12i } from '../../../__aeki__/styles/styleset/padding/pl12i'
import { pr12i } from '../../../__aeki__/styles/styleset/padding/pr12i'
import { formatDate } from '../../../__aeki__/modules/fields/date-field'
import { mt16 } from '../../../__aeki__/styles/styleset/margin/mt16'
import { withRouter } from '../../../__aeki__/contexts/with-router'
import { useCheckLogin } from '../../childcares/components/check-login'

export const Openings = withRouter((props: any) => {
  const history = useNavigate()
  const historyLocation = useLocation()
  const params = parseSearch(historyLocation, {})

  let styles: any

  if (Object.keys(params).length > 0) {
    const temp = {
      color1: `#${params.color1}`,
      color2: `#${params.color2}`,
      color3: `#${params.color3}`,
      font: params.font,
    }

    styles = {
      text: style({
        color: `${temp.color2} !important`,
        $nest: {
          '&:hover': {
            color: `${temp.color1} !important`,
          },
        },
      }),
      button: style({
        background: `${temp.color2} !important`,
        $nest: {
          '&:hover': {
            background: `${temp.color3} !important`,
          },
        },
      }),
    }
  }

  const url = `${process.env.REACT_APP_API_URL}${
    historyLocation.pathname.includes('/openings')
      ? historyLocation.pathname
      : `${historyLocation.pathname}/openings`
  }`
  const [post, $post] = useFetch({ data: [], totalPage: 0, page: 0 }, { isLoading: true })
  const [center, $center] = useObject<{ lng?: number; lat?: number }>({
    lat: props.post.payload.location.coordinates[1],
    lng: props.post.payload.location.coordinates[0],
  })
  const [pan, $pan] = useObject<{ lng?: number; lat?: number }>()
  const [, $bounds] = useObject<any>()
  const [, $radius] = useValue(5000)
  const [isSearching, $isSearching] = useValue(false)
  const [mapZoom, $mapZoom] = useCounter(11, { max: 15, min: 8 })
  const [data, $data] = useValue([])
  const [page, $page] = useValue(1)
  const [loadMore, $loadMore] = useValue()
  const checkLoginWrapper = useCheckLogin()

  useEffect(() => {
    if (post.mounted && historyLocation.pathname) {
      $post.get({ url, search: { page } }).then((payload: any) => {
        payload.data.map((row: any, key: number) => {
          if (row.type !== 'ad' && row.body.childcare.body.originalGroup) {
            const name = row.body.childcare.body.originalGroup.location.coordinates.join()
            if (childcareGroup[name]) {
              childcareGroup[name] = {
                ...childcareGroup[name],
                type: 'group',
                children: [
                  ...(childcareGroup[name].children || []),
                  row.body.childcare.body.originalGroup,
                ],
              }
            } else {
              childcareGroup[name] = {
                type: 'row',
                children: [row.body.childcare.body.originalGroup],
                ref: row.body.childcare.body.originalGroup,
                index: key,
              }
            }
          }
        })

        $data.set(payload.data)
      })
    }
  }, [post.mounted])

  useEffect(() => {
    const run = async () => {
      $post.get({ url, search: { page: page + 1 } }).then((payload: any) => {
        payload.data.map((row: any, key: number) => {
          if (row.type !== 'ad' && row.body.childcare.body.originalGroup) {
            const name = row.body.childcare.body.originalGroup.location.coordinates.join()
            if (childcareGroup[name]) {
              childcareGroup[name] = {
                ...childcareGroup[name],
                type: 'group',
                children: [
                  ...(childcareGroup[name].children || []),
                  row.body.childcare.body.originalGroup,
                ],
              }
            } else {
              childcareGroup[name] = {
                type: 'row',
                children: [row.body.childcare.body.originalGroup],
                ref: row.body.childcare.body.originalGroup,
                index: key,
              }
            }
          }
        })

        $data.set((prev: any) => [...prev, ...payload.data])
        $page.set((prev: any) => prev + 1)
      })
    }

    if (loadMore) {
      run()
    }
  }, [loadMore])

  const renderSubtitleItems = (items: any) => {
    return (
      items.length > 0 && (
        <Box
          className={classes(
            style({
              flexWrap: 'wrap',
            }),
          )}
          flex
        >
          {items.map((item: any, key: any) => {
            const { label, value, url, target, onClick } = item
            return (
              <Box
                baseline="background"
                className={classes(
                  p4,
                  mr4,
                  pl12i,
                  pr12i,
                  mb4,
                  style({ borderRadius: '16px !important', cursor: 'pointer' }),
                )}
                key={key}
                alignCenterX
                alignCenterY
                minHeight={32}
                onClick={onClick}
              >
                <Text className={mr4} baseline="surface" size="xs" listLink semiBold>
                  {label}
                </Text>
                <Text baseline="surface" size="xs" listLink>
                  <a href={url} target={target}>
                    {value}
                  </a>
                </Text>
              </Box>
            )
          })}
        </Box>
      )
    )
  }

  const childcareGroup: any = {}

  post.payload.data.map((row: any, key: number) => {
    if (row.type !== 'ad' && row.body.childcare.body.originalGroup) {
      const name = row.body.childcare.body.originalGroup.location.coordinates.join()
      if (childcareGroup[name]) {
        childcareGroup[name] = {
          ...childcareGroup[name],
          type: 'group',
          children: [
            ...(childcareGroup[name].children || []),
            row.body.childcare.body.originalGroup,
          ],
        }
      } else {
        childcareGroup[name] = {
          type: 'row',
          children: [row.body.childcare.body.originalGroup],
          ref: row.body.childcare.body.originalGroup,
          index: key,
        }
      }
    }
  })

  return (
    <>
      <Box baseline="none" row>
        <Box
          className={classes(pt40, paddingVerticalInner)}
          centerAutoX
          maxWidth={MAX_WIDTH}
          fullWidth
        >
          <Box className={mb16} relative>
            <GoogleLoader
              component={GoogleMap}
              loaderProps={{
                height: '100%',
                width: '100%',
              }}
              className={style({
                height: 400,
                width: '100%',
                overflow: 'hidden',
                borderRadius: 8,
              })}
              componentProps={
                center && {
                  marker: <Marker />,
                  centerMarker: <CenterMarker />,
                  center: center,
                  pan: pan,
                  $center: $center,
                  $radius: $radius,
                  $bounds: $bounds,
                  options: {
                    maxZoom: 15,
                    minZoom: 8,
                    zoom: mapZoom,
                  },
                  // lastTriggered: triggerMapUpdate,
                  zoom: mapZoom,
                  locations: Object.keys(childcareGroup).map((name: any) => {
                    const row = childcareGroup[name].ref

                    if (row && row.location) {
                      return {
                        location: {
                          children: childcareGroup[name].children,
                          location: row.location,
                          // focused: childcareGroup[name].children.some((a: any) => a.id === focused),
                          onClick: async () => {
                            if (childcareGroup[name].children.length > 1) {
                              await import('../../../modals/childcare-group')
                              await import('../../../modals/childcare')
                              Modal.push({
                                type: 'ChildcareGroup',
                                componentProps: {
                                  children: childcareGroup[name].children,
                                },
                              })
                            } else {
                              await import('../../../modals/childcare')
                              Modal.push({
                                type: 'Childcare',
                                componentProps: {
                                  ccp: { ...row },
                                  // filters: childcare.payload.filters,
                                  // currentFilters: currentFilters,
                                  // onFilter: (value: any) => {
                                  //   $filters.set((prev: any) => ({ ...prev, ...value }))
                                  //   if (value) {
                                  //     $childcare.get({
                                  //       search: {
                                  //         ...structureObj({
                                  //           ...flat(childcare.search),
                                  //           ...value,
                                  //         }),
                                  //         city: props.params.city,
                                  //         page: childcare.search.page,
                                  //       },
                                  //       resetSearch: true,
                                  //       updateGetParams: true,
                                  //       deleteFalse: true,
                                  //     })
                                  //   }
                                  // },
                                },
                              })
                            }
                          },
                        },
                        index: childcareGroup[name].index,
                        onClick: async () => {
                          await import('../../../modals/childcare')
                          Modal.push({
                            type: 'Childcare',
                            componentProps: {
                              ccp: { ...row },
                              // filters: childcare.payload.filters,
                              // currentFilters: currentFilters,
                              // onFilter: (value: any) => {
                              //   $filters.set((prev: any) => ({ ...prev, ...value }))
                              //   if (value) {
                              //     $childcare.get({
                              //       search: {
                              //         ...structureObj({
                              //           ...flat(childcare.search),
                              //           ...value,
                              //         }),
                              //         city: props.params.city,
                              //         page: childcare.search.page,
                              //       },
                              //       resetSearch: true,
                              //       updateGetParams: true,
                              //       deleteFalse: true,
                              //     })
                              //   }
                              // },
                            },
                          })
                        },
                      }
                    }
                  }),
                  // clear: triggerMapSearch,
                  // trigger: triggerMapUpdate,
                  // onChange: (map: any) => {
                  //   $center.set(map.center)

                  //   $location.set({
                  //     center: map.center,
                  //     bounds: [
                  //       [
                  //         `${map.location.lng1}`.replace('.', '_'),
                  //         `${map.location.lat1}`.replace('.', '_'),
                  //       ],
                  //       [
                  //         `${map.location.lng2}`.replace('.', '_'),
                  //         `${map.location.lat2}`.replace('.', '_'),
                  //       ],
                  //     ],
                  //     page: 1,
                  //   })
                  // },
                  // onZoom: (map: any) => {
                  //   $location.set({
                  //     radius: map.radius,
                  //     center: map.center,
                  //     bounds: [
                  //       [
                  //         `${map.location.lng1}`.replace('.', '_'),
                  //         `${map.location.lat1}`.replace('.', '_'),
                  //       ],
                  //       [
                  //         `${map.location.lng2}`.replace('.', '_'),
                  //         `${map.location.lat2}`.replace('.', '_'),
                  //       ],
                  //     ],
                  //   })
                  // },
                }
              }
            />
            <Box
              column
              baseline="none"
              alignRight
              absolute
              style={{
                right: 8,
                top: 8,
              }}
            >
              <Button
                onClick={() => {
                  $isSearching.set(true)
                  if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position: any) => {
                      $pan.set({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                      })
                      $isSearching.set(false)
                    })
                  }
                }}
                icon={
                  <span
                    className={classes(
                      'material-icons-two-tone',
                      f17i,
                      // STYLES.icon,
                      isSearching && STYLES.iconSpin,
                    )}
                  >
                    {isSearching ? 'hourglass_empty' : 'pin_drop'}
                  </span>
                }
                // label={isSearching ? 'Searching ...' : 'My Location'}
                baseline="surface"
                size="sm"
                className={mr4}
              />
              <Box className={classes(mr4)} baseline="none">
                <Button
                  baseline={$mapZoom.isMax() ? 'disabled' : 'surface'}
                  size="sm"
                  onClick={() => {
                    $mapZoom.increment()
                  }}
                  icon={<span className={classes('material-icons-two-tone', f14i)}>add</span>}
                  float
                />
              </Box>
              <Box baseline="none">
                <Button
                  baseline={$mapZoom.isMin() ? 'disabled' : 'surface'}
                  size="sm"
                  onClick={() => {
                    $mapZoom.decrement()
                  }}
                  icon={<span className={classes('material-icons-two-tone', f14i)}>remove</span>}
                  float
                />
              </Box>
            </Box>
          </Box>
          {data.map((item: any, key: any) => {
            const name = get('body.name', item, 'string')
            const childcareId = get('body.childcare.body.originalGroup.id', item, 'string')
            const childcareName = get('body.childcare.body.generalInformation.name', item, 'string')
            const childcareAddress = get(
              'body.childcare.body.generalInformation.addressLine1',
              item,
              'string',
            )
            const childcarePhone = get(
              'body.childcare.body.generalInformation.phoneNumber',
              item,
              'string',
            )

            const createdAt = get('createdAt', item, 'string')

            const items = renderSubtitleItems([
              {
                label: 'Phone',
                value: `${childcarePhone}`,
                url: `tel:${childcarePhone}`,
              },
              {
                label: 'Address',
                value: `${childcareAddress}`,
                // url: `/a/childcares?page=1&searchText=${childcareAddress}&openMap=true`,
                target: '__blank',
                onClick: () => {
                  $pan.set({
                    lat: item.body.childcare.body.originalGroup.location.coordinates[1],
                    lng: item.body.childcare.body.originalGroup.location.coordinates[0],
                  })
                },
              },
              {
                label: 'Posted on',
                value: `${formatDate(createdAt)}`,
              },
            ])

            return (
              <Box className={classes(key !== post.payload.data.length - 1 && mb32)} key={key} row>
                <Box flex spaceBetween alignBottom>
                  <A to={`/a/c/${childcareId}`} target="__blank">
                    <Box className={pr8} row>
                      <Text
                        className={classes(mb4, styles?.text)}
                        size="md"
                        shrink
                        link={!styles?.text}
                      >
                        {childcareName}
                      </Text>
                      <Heading baseline="surface" listLink>
                        {name}{' '}
                        <i className={classes('material-icons-two-tone', f16i, f14mdi)}>
                          open_in_new
                        </i>
                      </Heading>
                    </Box>
                  </A>
                  <Button
                    className={classes(hidemdi, styles?.button)}
                    label="More Info"
                    baseline="primary"
                    size="sm"
                    onClick={async () => {
                      globalThis?.window?.open?.(`/a/c/${childcareId}`, '_blank')
                    }}
                    square
                  />
                </Box>
                <Line className={classes(mt8, mb8)} />
                {items}
              </Box>
            )
          })}
          {post.payload.page <= post.payload.totalPage && (
            <Box className={mt16} alignCenterX>
              <Button
                label={post.meta.isLoading ? 'Loading...' : 'Load More'}
                baseline="primary"
                onClick={() => {
                  $loadMore.set(Date.now())
                }}
              />
            </Box>
          )}
          {!post.meta.isLoading && data.length === 0 && (
            <Box row>
              <Text size="md" className={mb8}>
                Please contact the centre to get assistance with finding childcares with openings.
              </Text>
              <Box>
                <Button
                  size="md"
                  label={'Contact the centre'}
                  baseline="primary"
                  onClick={checkLoginWrapper(async () => {
                    const { Modal } = await import('../../../__aeki__/components/modal')
                    await import('../../../modals/childcare-contact')

                    Modal.push({
                      type: 'ChildcareContact',
                      componentProps: {
                        ccp: props.post.payload,
                        values: {
                          ticketType: 'General Inquiry',
                        },
                      },
                    })
                  })}
                  icon={<span className={classes('material-icons-two-tone', f18i)}>mail</span>}
                  semiBold
                  square
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
})

const STYLES = stylesheet({
  iconSpin: {
    color: 'black !important',
    animationDuration: '4s',
    animationIterationCount: 'infinite',
    animationName: keyframes({
      '100%': {
        transform: 'rotate(360deg)',
      },
    }),
  },
})
